<template>
  <div>
    <div v-if="errors.length > 0" class="alert alert-danger">
      <p v-for="error in errors" :key="error" class="errors mb-0">
        {{ error }}
      </p>
    </div>
    <div>
      Populate {{ partnerLabel.toLowerCase() }}'s profile fields from
      <span :class="{'has-error':errors.modificationSource}">
        <select :value="modificationSource" name="modificationSource" class="form-control" @change="handleChange">
          <option value="" disabled>Select one</option>
          <option v-for="(display, $id) in availableModificationSources" :key="$id" :value="$id">{{ display }}</option>
        </select>
      </span>
    </div>
    <hr>
    <template v-if="modificationSource">
      <div v-for="(settings, fieldName) in fieldConfig" :key="fieldName">
        <template v-if="settings.enabled">
          Set the {{ partnerLabel.toLowerCase() }}'s <strong>{{ getDisplayName(fieldName) }}</strong> to
          <select v-model="settings.exportTag" name="exportTag" class="form-control">
            <option value="" selected="selected" disabled>
              Select one
            </option>
            <template v-if="modificationSource === 'event'">
              <option v-for="(eventSourceField) in config.sourceFields" :key="eventSourceField.tag" :value="eventSourceField.tag">
                {{ eventSourceField.tag }}
              </option>
            </template>
            <template v-if="modificationSource === 'block'">
              <option v-for="(blockSourceField) in config.blockFields" :key="blockSourceField.tag" :value="blockSourceField.tag">
                {{ blockSourceField.tag }}
              </option>
            </template>
          </select>
          <button v-if="!isRequired(fieldName)" type="button" class="btn btn-link text-danger" @click="disableField(fieldName)">
            <span class="sr-only">Remove Optional Field</span><span class="fa fa-trash" />
          </button>
        </template>
      </div>
      <div v-if="addableFields.length > 0">
        <select v-model="addField" name="addField" class="form-control" @change="enableField">
          <option value="" disabled>
            Add optional profile field
          </option>
          <option v-for="field in addableFields" :key="field" :value="field">
            {{ capitalizeField(field) }}
          </option>
        </select>
      </div>
    </template>
  </div>
</template>

<script>
import BaseComponent from '@/EventLogic/components/BaseComponent.vue';
import {capitalize, enumValidator} from "@/EventLogic/util";

export default {
  extends: BaseComponent,
  props: {
    id: String,
    modificationSource: {
      type: String,
      validator: enumValidator(['event', 'block'])
    },
    fields: {
      type: Object,
      default() {
        return {};
      }
    },
  },
  data() {
    return {
      fieldConfig: this.initFieldConfig(),
      addField: '',
    }
  },
  computed: {
    availableModificationSources() {
      const availableSources = {};

      if (this.config.sourceName) {
        availableSources.event = 'this event\'s data';
      }

      if (Object.keys(this.config.blockFields).length) {
        availableSources.block = 'this block\'s data';
      }

      return availableSources;
    },
    partnerLabel() {
      return this.config.supportPartnerLabel;
    },
    addableFields() {
      return Object.keys(this.fieldConfig).filter(fieldName => !this.fieldConfig[fieldName].enabled)
    },
  },
  watch: {
    fieldConfig: {
      handler () {
        this.$emit('update:fields', this.fieldConfig);
      },
      deep: true
    }
  },
  methods: {
    initFieldConfig() {
      const fieldConfig = {};
      Object.keys(this.config.supportPartnerProfileFields).forEach((fieldName) => {
        const config = this.fields[fieldName] ?? null;
        fieldConfig[fieldName] = {
          'enabled': config?.enabled ?? this.isRequired(fieldName),
          'exportTag': config?.exportTag ?? ''
        }
      });

      return fieldConfig;
    },
    getDisplayName(field) {
      switch (field) {
        case 'cell_phone':
          return 'Text Number';
        case 'home_phone':
          return 'Voice Number';
        default:
          return capitalize(field);
      }
    },
    isRequired(field) {
      return this.config.supportPartnerProfileFields[field] === 'required';
    },
    enableField() {
      this.fieldConfig[this.addField].enabled = true;
      this.addField = '';
    },
    disableField(fieldName) {
      this.fieldConfig[fieldName].enabled = false;
      this.fieldConfig[fieldName].exportTag = '';
    },
    capitalizeField(fieldName) {
      return capitalize(fieldName);
    },
    validate: function() {
      this.errors = [];

      Object.keys(this.config.supportPartnerProfileFields).forEach(fieldName => {
        if (this.isRequired(fieldName) && !this.fieldConfig[fieldName].exportTag) {
          this.errors.push(`${this.getDisplayName(fieldName)} is a required profile field and must be set`);
        } else if (this.fieldConfig[fieldName].enabled && !this.fieldConfig[fieldName].exportTag) {
          this.errors.push(`${this.getDisplayName(fieldName)} is not fully configured`);
        }
      });

      return this.errors.length === 0;
    }
  }
};
</script>
